<template>
  <label class="input-label" :id="id" :for="forId">
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'input-label',
  props: ['id', 'forId']
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .input-label {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    color: $dark;
    @include mq-up(md){
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/input/InputLabel.vue